import { MOCK_BACKEND, SERVER_URL } from "../constants";

function mockCheckHashState() {
  return { "exists": true,
  "status": "done"};
}



export default async function CheckHashState(
  hash,token
) {
  if (MOCK_BACKEND) {
    return mockCheckHashState();
  }
  let response;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Token " + token);
    
  var formdata = new FormData();
  formdata.append("mediaHash", hash);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect:'follow'
  };

  response = await fetch(
    SERVER_URL + "/v1/checkhashstatus/",
    requestOptions
  );

  if (response.status === 200) return response.json();
  return false;
}
